import React, { useState } from "react";
import { Button, TextField, CircularProgress } from "@mui/material";
import "./DisputeReasonDialog.css";
import { DISPUTE_REASON_MAX_LENGTH } from "../../../../../utils/constants";

const DisputeReasonDialog = ({
  isOpen,
  onClose,
  onSave,
  isLoading = false,
}) => {
  const [disputeReason, setDisputeReason] = useState("");
  const [error, setError] = useState("");

  const handleSave = () => {
    if (!disputeReason.trim()) {
      setError("Please enter a reason for the dispute");
      return;
    }
    onSave(disputeReason.trim());
  };

  const handleClose = () => {
    setDisputeReason("");
    setError("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="dispute-reason-modal-overlay">
      <div className="dispute-reason-modal-content">
        <div className="dispute-reason-modal-header">
          <h2 className="dispute-reason-title">Dispute BMS Passenger Count</h2>
          <button className="dispute-reason-modal-close" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="dispute-reason-modal-body">
          <p className="dispute-reason-description">
            Please provide a reason for disputing the BMS passenger count:
          </p>

          <div className="dispute-reason-textfield-container">
            <TextField
              multiline
              rows={4}
              fullWidth
              value={disputeReason}
              slotProps={{
                textarea: {
                  maxLength: DISPUTE_REASON_MAX_LENGTH,
                },
              }}
              onChange={(e) => {
                if (e.target.value.length <= DISPUTE_REASON_MAX_LENGTH) {
                  setDisputeReason(e.target.value);
                  if (error) setError("");
                }
              }}
              placeholder="Enter your reason for disputing the BMS passenger count..."
              error={!!error}
              helperText={error}
              className="dispute-reason-textfield"
            />
            <div className="dispute-reason-char-count">
              {disputeReason.length}/{DISPUTE_REASON_MAX_LENGTH}
            </div>
          </div>
        </div>

        <div className="dispute-reason-modal-actions">
          <Button
            variant="outlined"
            onClick={handleClose}
            disabled={isLoading}
            className="dispute-reason-cancel-button"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={isLoading || !disputeReason.trim()}
            className="dispute-reason-save-button"
          >
            {isLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Submit Dispute"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DisputeReasonDialog;
